var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublishedWithChanges(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_11435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_11435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 22.275C9.56667 22.125 8.475 21.775 7.475 21.225C6.475 20.675 5.60433 19.9833 4.863 19.15C4.121 18.3167 3.54167 17.3623 3.125 16.287C2.70833 15.2123 2.5 14.075 2.5 12.875C2.5 11.3917 2.80833 10.0207 3.425 8.76201C4.04167 7.50401 4.925 6.41667 6.075 5.50001H3.375V4.00001H8.75V9.37501H7.25V6.47501C6.2 7.24167 5.396 8.17901 4.838 9.28701C4.27933 10.3957 4 11.5917 4 12.875C4 14.8583 4.63333 16.5877 5.9 18.063C7.16667 19.5377 8.78333 20.4333 10.75 20.75V22.275ZM10.575 17.125L6.7 13.225L7.75 12.175L10.575 15L16.25 9.32501L17.3 10.4L10.575 17.125ZM15.25 21.775V16.4H16.75V19.3C17.7833 18.5 18.5833 17.55 19.15 16.45C19.7167 15.35 20 14.1583 20 12.875C20 10.8917 19.3667 9.16234 18.1 7.68701C16.8333 6.21234 15.2167 5.31667 13.25 5.00001V3.47501C15.6167 3.79167 17.5833 4.83334 19.15 6.60001C20.7167 8.36667 21.5 10.4583 21.5 12.875C21.5 14.3583 21.1917 15.7293 20.575 16.988C19.9583 18.246 19.075 19.3417 17.925 20.275H20.625V21.775H15.25Z",
    fill: "#4F0696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedWithChanges);
export default __webpack_public_path__ + "static/media/published_with_changes.7a8e9810f52679844bdd903caf6da4f8.svg";
export { ForwardRef as ReactComponent };